import makePurposeDetails from './makePurposeDetails'
import makeVendorDetails from './makeVendorDetails'


export default function getDetailsSections({ gvl, selectedDetails }) {
  const {
    id: selectedID,
    name: selectedName,
  } = selectedDetails

  // As of October 2023, there are only 20-30 purposes and 2 special features,
  // and Jona doesn't expect either to grow very much in the future, so this isn't
  // a performance concern. Whereas there are currently 700+ vendors and that number
  // is expected to grow.
  //
  // NOTE: Attempting to DRY this up would be akin to putting lipstick on a pig. This
  // needs to be reworked so we're not doing this silly "look for a matching name" thing.

  // I'm guessing that there are typically going to be fewer special features than
  // purposes to crawl over, so we'll check that one first.
  const isSpecialFeature = gvl.getSpecialFeatures().some(({ name }) => name === selectedName)

  if ( isSpecialFeature ) {
    return makePurposeDetails({
      purpose: selectedDetails,
      vendors: gvl.getVendorsBySpecialFeatureID(selectedID),
    })
  }

  const isPurpose = gvl.getPurposes().some(({ name }) => name === selectedName)

  if ( isPurpose ) {
    return makePurposeDetails({
      purpose: selectedDetails,
      vendors: gvl.getVendorsByPurposeID(selectedID),
    })
  }

  const vendorDetails = gvl.getVendorByID(selectedDetails.id)

  return makeVendorDetails(vendorDetails)
}
